<template>
  <v-footer height="auto">
    <v-layout justify-center row wrap>
      <v-btn
        v-for="link in menuItems"
        :key="link.title"
        :to="link.path"
        color="black"
        flat
        round
      >
        {{ link.title }}
      </v-btn>
      <v-flex grey lighten-5 py-3 text-xs-center black--text xs12>
        &copy; {{ new Date().getFullYear() }} —
        <strong>Pablo López Pérez</strong>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
//Pie de página
// @group Interfaz extra
export default {
  name: "Footer",
  data: () => ({
    menuItems: [
      { title: "Inicio", path: "/" },
      { title: "Más información", path: "/about" },
      { title: "Contacto", path: "/contact" }
    ]
  })
};
</script>

<style>
footer {
  margin-top: 10px;
}
</style>
